module.exports = __webpack_public_path__ + "img/bornutti21.c99d5d09.jpg";